import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { PrismComboSelectInput } from '@mylighthouse/prism-ember';
import BasePropertySelect, {
  type PropertyOption,
} from 'lumen/components/settings/users/base-property-select';

interface PropertySelectSignature {
  Args: {
    isSecondary?: boolean;
    onChange: (selectedOption: PropertyOption | null) => void;
    value: PropertyOption | null;
  };
}

export default class PropertySelect extends BasePropertySelect<PropertySelectSignature> {
  readonly allPropertiesOption: PropertyOption;

  get allOptions(): PropertyOption[] {
    return [this.allPropertiesOption, ...this.options];
  }

  get selectedOption(): PropertyOption {
    const value = this.args.value;
    if (!value) {
      return this.allPropertiesOption;
    }

    return this.allOptions.find((option) => option.id === value.id) ?? value;
  }

  constructor(owner: Owner, args: PropertySelectSignature['Args']) {
    super(owner, args);
    this.allPropertiesOption = {
      id: '',
      label: this.intl.t('settings.users.filter.all_properties'),
    };
  }

  @action
  handleChange(option: PropertyOption | null): void {
    this.args.onChange(option?.id ? option : null);
  }

  <template>
    <PrismComboSelectInput
      @horizontalPosition="right"
      @isSearchable={{true}}
      @isSecondary={{@isSecondary}}
      @onChange={{this.handleChange}}
      @onOpen={{this.onOpen}}
      @onSearch={{this.onSearch}}
      @options={{this.allOptions}}
      @unsafe_onLoadMore={{this.loadMoreTask.perform}}
      @value={{this.selectedOption}}
      data-test-id="property-select"
    />
  </template>
}

export type { PropertyOption };
